import { atom } from "jotai";

export type MediaType = {
  logoUrl: string | null;
  imageUrl: string | null;
  videoUrl: string | null;
};

export const videoLimitAtom = atom<number>(0);
export const videoLimitFinishedAtom = atom<boolean>(false);
